import { authHeader } from "@/_helpers";

export const bookersService = {
  getBookerPayments,
  bookerPaymentChangeStatus,
  bookerCreateAccount,
  updateMeetingBookers,
  getConfigContract,
  applyNonWorkingAllBookers,
  getOrderDistribution,
  unassignTargetOfBooker,
  getTargetsToAssing,
  assignTargetOfBooker,
  getBookerManager,
  getBookerManagers,
  removeInteraction,
  getBookerPipe,
  getBookerSharedPhones,
  getBookerDailyReports,
  getBookerPipeStats,
  getBookerRanking,
  queueBookerNotification,
  saveUserGeneral,
  saveUserWorkingBooker,
  saveUserPaymentDetail,
  saveLeadroomConfig,
  getPromptDaily,
  getElevenLabsCalls,
  getScoreOptions,
  assignMeetingToBooker,
  getRecruiterCountries,
  getEventsByRange,
  getDataMonitoringStats,
  getAiAgentBookerUserId,
};

const apiUrl = process.env.VUE_APP_ROOT_API;

function getConfigContract() {
  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };
  return fetch(`${apiUrl}/bookers/my-config`, requestOptions).then(handleResponse)
}

function updateMeetingBookers(payment_id, meetings_booked) {
  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify({ payment_id, meetings_booked }),
  };
  return fetch(
    `${apiUrl}/bookers/booker-payment-change-meetings`,
    requestOptions
  ).then(handleResponse);
}

function getBookerManager(){
    const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };
  return fetch(
    `${apiUrl}/bookers/get-booker-managers`,
    requestOptions
  ).then(handleResponse);
}

function getBookerManagers() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }

  return fetch(`${apiUrl}/bookers/get-booker-managers`, requestOptions).then(handleResponse)
}

function getBookerPayments(searchFilter) {
  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify({ searchFilter }),
  };
  return fetch(
    `${apiUrl}/bookers/booker-payments`,
    requestOptions
  ).then(handleResponse);
}

function getTargetsToAssing(bookerId = 0) {
  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
    body: JSON.stringify(),
  };
  return fetch(
    `${apiUrl}/bookers/get-targets-to-assign/${bookerId}`,
    requestOptions
  ).then(handleResponse);
}



function assignTargetOfBooker(bookerId = 0, body = {}) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify(body),
  }
  return fetch(`${apiUrl}/bookers/booker/${bookerId}`, requestOptions)
    .then(handleResponse)
}

function unassignTargetOfBooker(bookerId = 0, targetId = 0) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader('application/json'),
    body: JSON.stringify(),
  }
  return fetch(`${apiUrl}/bookers/booker/${bookerId}/target/${targetId}`, requestOptions)
    .then(handleResponse)
}

function applyNonWorkingAllBookers(day_non_working) {
  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify({ day_non_working }),
  };
  return fetch(
    `${apiUrl}/bookers/booker-apply-non-working-day`,
    requestOptions
  ).then(handleResponse);
}

function bookerPaymentChangeStatus(payment_id, payment_status_id) {
  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify({ payment_id, payment_status_id }),
  };
  return fetch(
    `${apiUrl}/bookers/booker-payment-change-status`,
    requestOptions
  ).then(handleResponse);
}

function bookerCreateAccount(user) {
  
  const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ user }),
    }

    window.dataLayer = window.dataLayer || []
    dataLayer.push({
      event: 'formSubmission',
      formType: 'create_account',
    })

    return fetch(`${apiUrl}/users/booker-create-account`, requestOptions)
      .then(handleResponse)
      .then((user) => {
        // login successful if there's a jwt token in the response
        if (user.token) {
          // store user details and jwt token in local storage to keep user logged in between page refreshes
          localStorage.setItem("user", JSON.stringify(user));
          // Initialize variables for user filter of priority product and category
          localStorage.setItem("priorityCategoryFilter", JSON.stringify({}));
          localStorage.setItem("priorityProductFilter", JSON.stringify({}));
        }
        return user;
      });
  
}

function getOrderDistribution(){
    const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
  };
  return fetch(`${apiUrl}/bookers/get-order-distribution`, requestOptions).then(handleResponse)
}

function removeInteraction(bookerId){
  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify({ bookerId }),
  };
  return fetch(`${apiUrl}/bookers/remove-interaction`, requestOptions).then(handleResponse)
}


function getPromptDaily(params){
  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(params)
  };
  return fetch(`${apiUrl}/bookers/get-prompt-daily`, requestOptions).then(handleResponse)
}

function getBookerDailyReports(bdr_user_id) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ bdr_user_id }),
  }
  return fetch(`${apiUrl}/bookers/get-booker-daily-reports`, requestOptions).then(
    handleResponse,
  )
}

function getElevenLabsCalls(data) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify(data),
  }
  return fetch(`${apiUrl}/bookers/get-eleven-labs-calls`, requestOptions).then(
    handleResponse,
  )
}




function getBookerPipe(filters) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ filters }),
  }
  return fetch(`${apiUrl}/bookers/get-booker-pipe`, requestOptions).then(
    handleResponse,
  )
}

function getBookerSharedPhones(ids) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ ids }),
  }
  return fetch(`${apiUrl}/bookers/get-booker-shared-phones`, requestOptions).then(
    handleResponse,
  )
}

function getBookerPipeStats(filters){
  const params = new URLSearchParams();
  if (filters.recruiterFilter) {
    params.append('recruiterFilter', filters.recruiterFilter);
  }
  if (filters.countryFilter) {
    params.append('countryFilter', filters.countryFilter);
  }
  if (filters.originFilter) {
    params.append('originFilter', filters.originFilter);
  }
  if (filters.typeTable) {
    params.append('typeTable', filters.typeTable);
  }
  if(filters.yearFilter){
    params.append('yearFilter', filters.yearFilter);
  }
  if(filters.period){
    params.append('period', filters.period);
  }
  if(filters.booker_type){
    params.append('booker_type', filters.booker_type);
  }
  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };
  return fetch(`${apiUrl}/bookers/get-booker-pipe-stats?${params.toString()}`, requestOptions).then(handleResponse)
}

function getDataMonitoringStats(filters){
  const params = new URLSearchParams();
  if (filters.recruiterFilter) {
    params.append('recruiterFilter', filters.recruiterFilter);
  }
  if (filters.countryFilter) {
    params.append('countryFilter', filters.countryFilter);
  }
  if (filters.originFilter) {
    params.append('originFilter', filters.originFilter);
  }
  if (filters.typeTable) {
    params.append('typeTable', filters.typeTable);
  }
  if(filters.yearFilter){
    params.append('yearFilter', filters.yearFilter);
  }
  if(filters.period){
    params.append('period', filters.period);
  }
  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };
  return fetch(`${apiUrl}/admin/get-data-monitoring?${params.toString()}`, requestOptions).then(handleResponse)
}

function getBookerRanking(filters) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ filters })
  }
  return fetch(`${apiUrl}/bookers/get-booker-ranking?cache=true&time=1800&role=${filters.role}`, requestOptions)
    .then( handleResponse,
  )
}

function queueBookerNotification(user_id, template_id){
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ user_id, template_id })
  }
  return fetch(`${apiUrl}/bookers/queue-booker-notification`, requestOptions)
    .then( handleResponse,
  )
}

function saveUserGeneral(user_id , booker_manager_id, setup_call, booker_level_id, booker_notes, user_bdr_status_id, starting_date, country_id, recruiter_id, discord_id, ringover_phone, booker_type, papaya_beneficiary_id){
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ user_id , booker_manager_id, setup_call, booker_level_id, booker_notes, user_bdr_status_id, starting_date, country_id, recruiter_id, discord_id, ringover_phone, booker_type, papaya_beneficiary_id }),
  }

  return fetch(`${apiUrl}/bookers/update-booker-config`, requestOptions).then(handleResponse)
}



function saveUserWorkingBooker(user_id , working_hours_availability, days_non_working){
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ user_id , working_hours_availability, days_non_working }),
  }

  return fetch(`${apiUrl}/bookers/update-booker-working-hours`, requestOptions).then(handleResponse)
}

function saveUserPaymentDetail(user_id, saved_bank_detail){
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ user_id, saved_bank_detail }),
  }

  return fetch(`${apiUrl}/bookers/update-booker-payment-details`, requestOptions).then(handleResponse)
}

function saveLeadroomConfig(user_id, bdr_client_ids, bdr_target_ids, spoken_language_ids, link_temperature_ids){
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ user_id, ...bdr_client_ids, bdr_target_ids, spoken_language_ids, link_temperature_ids }),
  }

  return fetch(`${apiUrl}/bookers/update-booker-lead-config`, requestOptions).then(handleResponse)
}

function getScoreOptions(user_id, start_date, end_date){
  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
    body: JSON.stringify(),
  };
  return fetch(
    `${apiUrl}/bookers/get-score-options?user_id=${user_id}&start_date=${start_date}&end_date=${end_date}`,
    requestOptions
  ).then(handleResponse);
}

function assignMeetingToBooker(notification_id, link_event_id, link_id){
    const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify({ notification_id, link_event_id, link_id }),
  }

  return fetch(`${apiUrl}/bookers/booker-assign-meeting`, requestOptions).then(handleResponse)
}

function getRecruiterCountries() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }

  return fetch(`${apiUrl}/bookers/get-recruiter-countries`, requestOptions).then(handleResponse)
}

function getEventsByRange(params) {
  let userId = params.user_id
  if (params.account_id != null && params.account_id !== '') {
    try {
      const decoded = typeof atob !== 'undefined' ? atob(params.account_id) : ''
      userId = decoded ? parseInt(decoded, 10) : params.user_id
    } catch (e) {
      userId = params.user_id
    }
  }
  const body = {
    user_id: userId,
    hours_back: params.hours_back != null ? params.hours_back : 2,
    hours_forward: params.hours_forward != null ? params.hours_forward : 30,
  }
  const requestOptions = {
    method: 'POST',
    headers: authHeader('application/json'),
    body: JSON.stringify(body),
  }
  return fetch(`${apiUrl}/bookers/calendar/events-by-range`, requestOptions).then(handleResponse)
}

function getAiAgentBookerUserId(clientId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader('application/json'),
  }
  return fetch(
    `${apiUrl}/bookers/ai-agent-booker-user-id?client_id=${clientId}`,
    requestOptions,
  ).then(handleResponse)
}

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        logout();
      }

      const error = data || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}
